<template>
  <div>
    <Header />
    <div class="main">
      <div class="c">
        <div class="title">
          <div class="return" @click="back()">
            <a-icon type="left" />
            <span>返回</span>
          </div>
          <span class="chapterName">{{ this.chapterName }}</span>
        </div>
        <div class="paper">
          <div class="paper-left">
            <component :is="tebActive" :questionData="questionData" :key="questionData.index"></component>
          </div>
          <div class="paper-right">
            <div class="paper-right-title">答题卡</div>
            <div class="paper-right-selects">
              <ul>
                <li v-for="(item, index) in questions" :key="item.id" ref="li" :style="{
                    background:
                      index == currentIndex ? '#2462F5' : item.answerState,
                    color: index == currentIndex ? '#fff' : item.answerColor,
                  }" @click="toQuestion(item, index)" :class="{is_right:item.is_right != 0}">
                  {{ item.num }}
                  <img v-show="item.is_sign == '1' " src="../../../assets/sign.png" alt="" />
                </li>
              </ul>
            </div>
            <div class="tip">
              <span>正确</span>
              <div class="answered"></div>
              <span>错误</span>
              <div class="error"></div>
              <span>未答</span>
              <div class="noAnswer"></div>
            </div>
            <div class="submit" @click="again()">再次作答</div>
          </div>
        </div>
        <div class="button-box" v-if="this.questions.length > 1">
          <div class="buPrevious" ref="buPrevious" @click="previous()">
            上一题
          </div>
          <div class="buNext" ref="buNext" @click="next()">下一题</div>
        </div>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import radio from "./AgainPractice/radio";
import checkbox from "./AgainPractice/checkbox";
import fillBlanks from "./AgainPractice/fillBlanks";
import quesAnswer from "./AgainPractice/quesAnswer";
import combination from "./AgainPractice/combination";
import judge from "./AgainPractice/judge";
import services from "../../../config/services";
import { mapState } from "vuex";
export default {
  name: "AgainPractice",
  components: { Footer, Header, radio, checkbox, fillBlanks, quesAnswer, judge, combination },
  data () {
    return {
      tebActive: "",
      questionData: "",
      questions: "",
      chapter_id: this.$route.query.chapter_id,
      chapterName: this.$route.query.name,
      exe_id: this.$route.query.exe_id,
      currentIndex: 0, //当前位置
      arr: [],
    };
  },
  computed: {
    ...mapState({
      userAllInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  created () {
    let that = this;
    services
      .getUserExercisesCard({
        chapter_id: this.chapter_id,
        exe_id: this.exe_id,
        is_again: 2,
      })
      .then((res) => {
        this.questions = res.data.items;
        this.questions.forEach(function (item) {
          that.color(item);
        });
        services
          .getUserExercisesQuestion({
            chapter_id: this.chapter_id,
            que_id: this.questions[0].id,
            exe_id: this.exe_id,
            is_again: 2,
          })
          .then((second) => {
            //this.questions[0] = res.data;
            this.questions[0] = Object.assign(this.questions[0], second.data);
            if (this.questions[0].type == "1") {
              this.tebActive = "radio";
            }
            if (this.questions[0].type == "2") {
              this.tebActive = "checkbox";
            }
            if (this.questions[0].type == "3") {
              this.tebActive = "judge";
            }
            if (this.questions[0].type == "4") {
              this.tebActive = "quesAnswer";
            }
            if (this.questions[0].type == "5") {
              this.tebActive = "combination"; // 为5 组合题
            }
            this.questionData = {
              data: this.questions[0],
              index: this.currentIndex,
              isAssess: true,
            };
          });
      });
  },
  watch: {
    currentIndex: function (val) {
      if (val == this.questions.length - 1) {
        this.$refs.buNext.style.background = "#ECEAEA";
        this.$refs.buNext.style.color = "#999999";
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.cursor = "not-allowed";
        this.$refs.buPrevious.style.cursor = "pointer";
      }
      if (val == 0) {
        this.$refs.buPrevious.style.background = "#ECEAEA";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.cursor = "not-allowed";
        this.$refs.buNext.style.cursor = "pointer";
      }
      if (val > 0 && val < this.questions.length - 1) {
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.cursor = "pointer";
        this.$refs.buNext.style.cursor = "pointer";
      }
    },
  },
  methods: {
    // 返回
    back () {
      let code = this.userAllInfo.school_code ? this.userAllInfo.school_code : localStorage.getItem("schoolCode")
      this.$router.push({
        path: `/${code}/user/myPractice`,
      });
    },
    //跳转到该题
    toQuestion (val, index) {
      this.currentIndex = index;
      services.getUserExercisesQuestion({
        chapter_id: this.chapter_id,
        que_id: val.id,
        exe_id: this.exe_id,
        is_again: 2,
      }).then((res) => {
        if (res.code == '0000') {
          this.questions[index] = Object.assign(this.questions[index], res.data);
          if (this.questions[index].type == "1") {
            this.tebActive = "radio";
          } else if (this.questions[index].type == "2") {
            this.tebActive = "checkbox";
          } else if (this.questions[index].type == "4") {
            this.tebActive = "quesAnswer";
          } else if (this.questions[index].type == "3") {
            this.tebActive = "judge";
          } else if (this.questions[index].type == "5") {
            this.tebActive = "combination";
          }
          this.questionData = {
            data: this.questions[index],
            index: index,
            isAssess: true,
          };
        }
      });
    },
    //跳转下一题
    next () {
      if (this.currentIndex < this.questions.length - 1) {
        this.$refs.li[this.currentIndex + 1].click();
      }
      if (this.currentIndex == this.questions.length - 1) {
        this.$refs.buNext.style.background = "#ECEAEA";
        this.$refs.buNext.style.color = "#999999";
      } else {
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
      }
    },
    //跳转上一题
    previous () {
      if (this.currentIndex > 0) {
        this.$refs.li[this.currentIndex - 1].click();
      }
      if (this.currentIndex == 0) {
        this.$refs.buPrevious.style.background = "#ECEAEA";
        this.$refs.buPrevious.style.color = "#999999";
      } else {
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
      }
    },
    //再次作答
    again () {
      let that = this;
      services.getUserExercisesCard({
        chapter_id: that.chapter_id,
        exe_id: that.exe_id,
        is_again: 1, // 只有点击再次作答时，调用答题卡接口时again=1；其他的情况都是2
      }).then((res) => {
        if (res.code == '0000') {
           that.$router.push({
            path: `/${that.userAllInfo.school_code}/user/myPractice/NowPractice`,
            query: {
              chapter_id: that.$route.query.chapter_id,
              name: that.$route.query.name,
              exe_id: that.$route.query.exe_id,
            },
          });
        }
      })
     
    },
    //过滤
    color (item) {
      if (item.is_right != 0) {
        if (item.is_right == "1") {
          this.$set(item, "answerState", "#D7F3EA");
          this.$set(item, "answerColor", "#32B387");
        } else {
          this.$set(item, "answerState", "#FAE7E6");
          this.$set(item, "answerColor", "#EC8D8B");
        }
      } else {
        this.$set(item, "answerState", "#ffffff");
        this.$set(item, "answerColor", "#666666");
      }
    },
  },
};
</script>

<style scoped>
.c {
    padding-top: 10px;
}
.return {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2462f5;
    line-height: 32px;
    cursor: pointer;
    float: left;
    margin-top: 3px;
}
.main {
    background: #f6f6f6;
}
.UserNav {
    box-shadow: 0px 0px 21px 0px rgba(25, 52, 116, 0.15);
}
.title {
    height: 40px;
    background: #fff;
    border-top: 3px solid #90b1ff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    text-align: center;
}
.title .chapterName {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 40px;
}
.paper {
    margin-top: 20px;
    position: relative;
    padding-bottom: 80px;
}
.paper-left {
    width: calc(100% - 330px);
    height: auto;
    min-height: 530px;
    background: #ffffff;
    margin-right: 20px;
    float: left;
    margin-bottom: 10px;
}
.paper-right {
    width: 310px;
    /* max-height: 566px; */
    background: #ffffff;
    float: left;
    padding-bottom: 20px;
}
.paper-right-title {
    width: 56px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #14202c;
    line-height: 32px;
    margin-top: 10px;
    margin-left: 30px;
}
.paper:after {
    content: '';
    display: block;
    clear: both; /* height: 0;overflow: hidden; 为了解决 IE 浏览器的兼容问题 */
    height: 0;
    overflow: hidden; /* visibility:hidden;为了去隐藏content中的内容 */
    visibility: hidden;
}
.button-box {
    padding-top: 30px;
    box-sizing: border-box;
    margin-top: 10px;
    height: 80px;
    background: #fff;
    position: fixed;
    bottom: 0;
    width: 870px;
    z-index: 10;
}
.button-box div {
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 22px;
    margin: 0 166px;
    display: inline-block;
    vertical-align: top;
}
.button-box:after {
    content: ' ';
    clear: both;
    display: block;
    height: 0;
    visibility: hidden;
}
.buPrevious {
    background: rgb(236, 234, 234);
    color: rgb(153, 153, 153);
    cursor: not-allowed;
}
.buPrevious:hover {
    background: #bbcdf3 !important;
    color: #ffffff !important;
}
.buNext {
    background: #2462f5;
    color: #fff;
    cursor: pointer;
}
.buNext:hover {
    background: #134bce !important;
    color: #ffffff !important;
}
ul {
    display: flex;
    flex-wrap: wrap;
    margin-left: 30px;
}
li {
    width: 32px;
    padding: 0 0;
    height: 32px;
    line-height: 32px;
    text-align: center;
    float: left;
    margin-right: 20px;
    margin-top: 15px;
    font-size: 12px;
    border: 1px solid #e4e4e4;
    cursor: pointer;
    position: relative;
}
li.is_right {
    background: rgb(219, 230, 253);
    color: rgb(36, 98, 245);
}
li:hover {
    background: #dbe6fd !important;
    color: #999999 !important;
}
li img {
    height: 14px;
    width: 14px;
    position: absolute;
    top: -7px;
    right: -7px;
}
.tip {
    height: 32px;
    display: flex;
    align-items: center;
    margin-left: 37px;
    margin-top: 30px;
    margin-bottom: 30px;
}
.tip span {
    width: 29px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 32px;
    margin-right: 8px;
}
.answered {
    width: 16px;
    height: 16px;
    background: #d7f3ea;
    float: left;
    margin-right: 28px;
}
.noAnswer {
    width: 16px;
    height: 16px;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    float: left;
}
.submit {
    color: #fff;
    width: 220px;
    height: 30px;
    background: #2462f5;
    border-radius: 22px;
    line-height: 30px;
    text-align: center;
    margin-left: 45px;
    cursor: pointer;
}
.submit:hover {
    background: #134bce !important;
    color: #ffffff !important;
}
.error {
    background: #fae7e6;
    width: 16px;
    height: 16px;
    float: left;
    margin-right: 28px;
}
.paper-right-selects {
    overflow-y: auto;
}
::-webkit-scrollbar-thumb {
    background-color: #dddddd;
    background-clip: padding-box;
    min-height: 28px;
}
</style>